

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { SubscriptionPlanType, SubscriptionPlanView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminSubscriptions } from "@/lib/query/core/invalidation";

type CreateSubscriptionPlanInput = {
  nameAr: string;
  nameEn?: string;
  type: SubscriptionPlanType;
  amount: number;
  periodDays: number;
  isActive: boolean;
};

export function useCreateSubscriptionPlanMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: CreateSubscriptionPlanInput) =>
      apiJsonClient<SubscriptionPlanView>(endpoints.admin.subscriptions, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input),
      }),
    onSuccess: async () => {
      await invalidateAdminSubscriptions(queryClient);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
